<script>
import { Helper, debounce } from '@/mixin/helper'
import Multiselect from 'vue-multiselect'
import { required, macAddress, maxLength, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { GET_DEVICE_CODE } from '@/services/api/master/tracking'
import { isLowercase, isAlphaNum } from '@/helpers/validators'
import * as pinDescriptions from '@/services/rest-api-sms/lib/pin-description/pin-description'
import * as devices from '@/services/rest-api-tools/lib/device/device'
import * as masterDataSensors from '@/services/rest-api-tools/lib/masterdata/sensor'
import * as commandSensorSettings from '@/services/rest-api-tools/lib/command/sensor_setting'
import * as sensorApi from '@/services/rest-api-sms/lib/sensor/sensor'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import * as canbusFormulasApi from '@/services/rest-api-sms/lib/canbus-formulas/canbus-formulas'
import * as deviceCommandApi from '@/services/rest-api-sms/lib/device-command/device-command'
import * as pinCommandApi from '@/services/rest-api-sms/lib/pin-command/pin-command'
import * as pinTypeApi from '@/services/rest-api-sms/lib/pin-type/pin-type'
import * as sensorTypeApi from '@/services/rest-api-sms/lib/sensor-type/sensor-type'

export default {
  props: {
    region: {
      type: String,
      default: 'SG',
    },
  },
  components: {
    Multiselect,
  },
  mixins: [Helper],
  apollo: {
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
  },
  data() {
    return {
      dataSensorTable: [],
      vehicles: [],
      vehicleId: null,
      imei: null,
      observer: null,
      size: 10,
      search: '',
      options: [
        { value: 'disable', text: 'Disable' },
        { value: 'enable', text: 'Enable' },
      ],
      tblSensor: [
        {
          key: 'sensor_name',
          label: 'Tipe Sensor',
        },
        {
          key: 'pin',
          label: 'PIN',
          thClass: 'text-center mc-table--250',
        },
        {
          key: 'status',
          label: 'Status',
          thClass: 'text-center mc-table--250',
        },
        {
          key: 'action',
          label: 'Action',
        },
      ],
      device: {
        device: [],
      },
      deviceTypes: {
        deviceType: [],
      },
      sensors: [],
      sensorDevices: [],
      sensorTypes: null,
      deviceName: null,
      deviceType: null,
      pinCodes: [],
      initialDeviceData: {},
      loading: false,
      showModalMacAddress: false,
      form: {
        macAddress: null,
      },
      modalConfirm: false,
      currentItem: null, // Variabel untuk menyimpan item yang sedang diproses
      pinDescriptionList: [],
      firstVehicle: null,
      showModalTFT100: false,
      tftForm: {
        brand: null,
        model: null,
      },
      brands: [],
      models: [],
      currentTFTItem: null,
    }
  },
  validations: {
    form: {
      macAddress: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(12),
        macAddress, // Batas maksimal 12 karakter
        isLowercase,
        isAlphaNum,
      },
    },
    tftForm: {
      model: { required },
      brand: { required },
    },
  },
  computed: {
    filterTable() {
      return this.dataSensorTable.filter((item) =>
        item.epDevice.device.some((e) => e.code === this.deviceType)
      )
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  async mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    await this.getVehicles()
    await this.getSensors()
    await this.getPinCodes()
    await this.getPinDescriptions()

    this.initialDeviceData = JSON.parse(localStorage.getItem('device'))
    this.imei = this.initialDeviceData?.imei
    if (this.imei) {
      this.$nextTick(async () => {
        await this.getDeviceDetailFromIMEI()
      })
    }
  },
  watch: {
    region() {
      this.onChangeRegion()
    },
  },
  methods: {
    async getBrands() {
      try {
        const res = await canbusFormulasApi.getBrands(this.region)
        this.brands = res.data || res // sesuaikan struktur response
      } catch (error) {
        this.handleError(error)
      }
    },
    async onBrandChange(value, brand) {
      try {
        if (brand) {
          const params = {
            brand: brand,
          }
          const res = await canbusFormulasApi.getModels(params, this.region)
          this.models = res.data || res
        }
      } catch (error) {
        this.handleError(error)
      }
    },

    async onChangeRegion() {
      this.observer = new IntersectionObserver(this.infiniteScroll)
      await this.getVehicles()
      await this.getSensors()
      await this.getPinCodes()
      await this.getPinDescriptions()

      this.initialDeviceData = this.firstVehicle
      this.imei = this.initialDeviceData?.imei
      if (this.imei) {
        this.$nextTick(async () => {
          await this.getDeviceDetailFromIMEI()
        })
      }
    },
    async sendCommand(input, sensorType) {
      const response = await commandSensorSettings.create(
        {
          ...input,
          sensor_type: sensorType,
        },
        this.region
      )

      if (response.status === 200) {
        if (input.is_enable) {
          this.$toast.success(`Sensor berhasil diaktifkan`)
        } else {
          this.$toast.success(`Sensor berhasil dihapus`)
        }
      }

      this.getSensorTypesFromVehicleID()
    },

    isHasAccess() {
      if (
        !Helper.methods.getAccessRight('qcDevice') &&
        !this.hasAccess(['sms-device-setting:create', 'sms-device-setting:update'])
      ) {
        this.$toast.error(this.$t('sensor.noAccessToChange'))
        return false
      } else return true
    },

    async checkMacAddressCommand(item) {
      const commandResponse = await deviceCommandApi.getByDeviceCodeSensorCodePinCode(
        this.deviceType,
        item.sensor_code,
        item.pin_code
      )
      return commandResponse?.show_mac_address || false
    },

    async executeSave(item, extraPayload = {}) {
      const payload = {
        command: item.sensor_type,
        mac_address: item.mac_address,
        pin_code: item.pin_code,
        sensor_code: item.sensor_code,
        ...extraPayload, // field tambahan dari modal TFT100
      }
      const response = await sensorApi.create(this.vehicleId, payload, this.region)
      if (response.status === 200 || response.status === 201) {
        this.$toast.success(`Sensor berhasil diaktifkan`)
      }
      this.getSensorTypesFromVehicleID()
    },

    async saveTFT100() {
      this.$v.tftForm.$touch()
      if (this.$v.tftForm.$error) {
        return
      }
      const extra = {
        brand: this.tftForm.brand,
        model: this.tftForm.model,
      }
      try {
        await this.executeSave(this.currentTFTItem, extra)
        this.showModalTFT100 = false
      } catch (error) {
        this.handleError(error)
      }
    },

    async save(item, modalOpen) {
      this.currentItem = item
      item.pin_code = item.pin.pin_code

      let params = {
        filters: `deviceCode:eq:${this.deviceType}`,
      }
      const dataSensor = await pinCommandApi.get(params)
      dataSensor?.forEach((data) => {
        if (data.sensor_code === item.sensor_code && data.pin_code === item.pin_code) {
          item.sensor_type = data.command
        }
      })

      if (!this.isHasAccess()) return

      if (item.status.value == 'enable') {
        // Cek apakah sensor yang diaktifkan adalah sensor OBD.
        // Sesuaikan identifier di bawah dengan kode/nama sensor OBD di sistem Anda.
        const sensorCode = String(item.sensor_code ?? '').toUpperCase()
        const sensorName = String(item.sensor_name ?? '').toUpperCase()
        const sensorType = String(item.sensor_type ?? '').toLowerCase()

        const isOBDSensor =
          sensorCode === 67 || sensorName === 'OBD' || sensorType.includes('obd')

        // Popup brand & model HANYA muncul untuk device TFT100 DAN sensor OBD
        if ((this.deviceType === 2010 || this.deviceName?.includes('TFT100')) && isOBDSensor) {
          this.currentTFTItem = item
          this.tftForm = { brand: null, model: null }
          await this.getBrands() // ambil daftar brand
          this.showModalTFT100 = true
          return // hentikan proses, nanti lanjut dari modal
        }

        try {
          if (!modalOpen) {
            const allowedMacAddress = await this.checkMacAddressCommand(item)
            if (allowedMacAddress) {
              this.form.macAddress = null
              this.showModalMacAddress = true
              return
            }
          }
        } catch (error) {
          console.error('Error checking device command:', error)
        }
        const payload = {
          command: item.sensor_type,
          mac_address: item.mac_address,
          pin_code: item.pin_code,
          sensor_code: item.sensor_code,
        }
        const response = await sensorApi.create(this.vehicleId, payload, this.region)
        if (response.status === 200 || response.status === 201) {
          this.$toast.success(`Sensor berhasil diaktifkan`)
        }
        this.getSensorTypesFromVehicleID()
      } else if (item.status.value == 'disable') {
        const payload = {
          command: item.sensor_type,
        }
        const response = await sensorApi.remove(
          this.vehicleId,
          item.sensor_code,
          item.pin_code,
          payload,
          this.region
        )
        if (response.status === 200) {
          this.$toast.success(`Sensor berhasil dihapus`)
        }
        this.getSensorTypesFromVehicleID()
      }
    },

    async getSensorTypesFromVehicleID() {
      this.loading = true
      await this.mapDataSensorFromPinCommand()
      if (this.vehicleId) {
        const sensors = await masterDataSensors.getByVehicleId(this.vehicleId, this.region)

        this.sensorTypes = sensors.sensor_type
        if (this.sensorTypes && sensors.vehicle_id != 0) {
          for (let i = 0; i < this.dataSensorTable.length; i++) {
            const row = this.dataSensorTable[i]
            const obj = this.sensorTypes.find((o) => o.sensor_code === row.sensor_code)

            if (!obj) continue // Jika tidak ditemukan, lewati iterasi

            const pinDesc = this.pinDescriptionList?.find(
              (item) => item.pin_code === obj.pin_code && item.sensor_code === row.sensor_code
            )
            if (pinDesc) obj.pin_name = pinDesc.pin_desc
            row.pin = {
              pin_code: obj.pin_code,
              pin_name: obj.pin_name,
              old_pin_code: obj.pin_code,
            }
            row.status = { value: 'enable', text: 'Enable' }
            row.mac_address = obj.mac_address
          }
        }
      }
      this.loading = false
    },
    async mapDataSensorFromPinCommand() {
      this.loading = false
      let params = {
        filters: `deviceCode:eq:${this.deviceType}`,
      }
      let mappedData = {}
      let arrData = []
      const dataSensor = await pinCommandApi.get(params)
      dataSensor?.forEach((data) => {
        const sensor_name = this.mapSensorName(data.sensor_code)

        if (!mappedData[`${data.sensor_code}`]) {
          mappedData[`${data.sensor_code}`] = data
          mappedData[`${data.sensor_code}`]['pin'] = null
          mappedData[`${data.sensor_code}`]['status'] = null
          mappedData[`${data.sensor_code}`]['pin_options'] = []
          mappedData[`${data.sensor_code}`]['sensor_name'] = sensor_name
          mappedData[`${data.sensor_code}`]['sensor_type'] = data.command
        }
        let pin_name = this.mapPinName(data.pin_code, data.sensor_code)
        const isNewPinOptions = !mappedData[`${data.sensor_code}`]['pin_options'].find(
          (e) => e.pin_name === pin_name
        )
        if (isNewPinOptions) {
          mappedData[`${data.sensor_code}`]['pin_options'].push({
            pin_name: pin_name,
            pin_code: data.pin_code,
          })
        }
      })
      Object.keys(mappedData).forEach((data) => {
        arrData.push(mappedData[data])
      })
      this.loading = true
      this.dataSensorTable = arrData
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          if (!errorData.details && errorData.message) {
            this.$toast.error(`${errorData.message}`)
            return
          }
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else if (errorStatus === 404) {
          this.$toast.error(this.$t('error.pinNotFound'))
        } else {
          this.$toast.error(this.$t('error.pinUnavailable'))
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    async getVehicles(_params) {
      let params = {
        page: 1,
        limit: this.size,
        search: this.search,
        filters: ["imei != ''", "imei != ' '", 'imei is not null'],
      }

      if (_params) {
        params.page = _params.page
        params.limit = _params.limit
        params.search = _params.search
      }
      const vehicles = await vehicleApi.get(params, this.region)

      if (!vehicles?.data) return
      this.firstVehicle = vehicles.data.paginated_result[0]
      return vehicles
    },

    fetchOptions: debounce(function (search) {
      this.search = search
      this.getVehicles()
    }, 600),

    async onClose() {
      await this.getDeviceDetailFromIMEI()
      this.observer.disconnect()
    },

    mapDeviceName(device_code) {
      for (const device of this.deviceTypes.deviceType) {
        if (device.deviceCode === device_code) return device.deviceName
      }
    },

    mapPinName(pin_code, sensor_code) {
      let pin_name = this.pinCodes?.find((e) => e.pin_code === pin_code)?.pin_name
      const pinDesc = this.pinDescriptionList?.find(
        (item) => item.pin_code === pin_code && item.sensor_code === sensor_code
      )
      if (pinDesc) pin_name = pinDesc.pin_desc
      return pin_name
    },

    mapSensorName(sensor_code) {
      return this.sensors?.find((e) => e.sensor_code === sensor_code)?.sensor_name
    },

    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.size += 10
        await this.$nextTick()
        this.getVehicles()
        ul.scrollTop = scrollTop
      }
    },

    async getDeviceDetailFromIMEI() {
      if (!this.imei) return
      const device = await devices.get(
        typeof this.imei === 'string' ? this.imei : this.imei.imei,
        this.region
      )

      this.deviceName = device.data.deviceType.deviceName
      this.deviceType = device.data.deviceCode
      this.vehicleId = device.data.vehicleId
      await this.getSensorTypesFromVehicleID()
    },

    async getPinCodes() {
      try {
        let params = {
          page: 1,
          limit: 1,
        }
        let pinTypeResponse = await pinTypeApi.get(params, this.region)
        if (pinTypeResponse.status) {
          if (pinTypeResponse.metadata.total_count > 1) {
            params.limit = pinTypeResponse.metadata.total_count
            pinTypeResponse = await pinTypeApi.get(params, this.region)
          }
          this.pinCodes = pinTypeResponse?.data?.paginated_result
        }
      } catch (error) {
        this.handleError(error)
      }
    },

    async getPinDescriptions() {
      let params = {
        limit: 1,
        page: 1,
      }
      const pinDesc = await pinDescriptions.get(params)
      if (pinDesc) {
        params.limit = pinDesc.metadata.total_count
        const pinDescList = await pinDescriptions.get(params)
        this.pinDescriptionList = pinDescList.data.paginated_result
      }
    },

    async getSensors() {
      try {
        let params = {
          limit: 1,
          page: 1,
        }
        let sensorTypeResponse = await sensorTypeApi.get(params, this.region)
        if (sensorTypeResponse.status) {
          if (sensorTypeResponse.metadata.total_count > 1) {
            params.limit = sensorTypeResponse.metadata.total_count
            sensorTypeResponse = await sensorTypeApi.get(params, this.region)
          }
          this.sensors = sensorTypeResponse?.data?.paginated_result
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    onPinChange(value, item) {
      item.mac_address = null
    },
    async handleSubmit() {
      this.$v.form.macAddress.$touch()
      if (this.$v.form.macAddress.$error) {
        return
      }

      this.loading = true
      try {
        this.currentItem.mac_address = this.form.macAddress
        this.showModalMacAddress = false // tutup modal
        await this.save(this.currentItem, true) // lanjutkan proses save
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<template>
  <div>
    <h4 class="card-title">Pilih Perangkat</h4>
    <b-card>
      <b-row>
        <b-col sm="12" md="3">
          <b-form-group id="imeiSensors">
            <FormulateInput
              type="select-resourceful"
              v-model="imei"
              placeholder="Pilih IMEI"
              :optionsGetter="getVehicles"
              :optionLabelFn="
                ({ item }) => {
                  return item.imei
                }
              "
              class="pt-0"
              trackBy="imei"
              @input="onClose"
              :allow-empty="false"
              :initialObject="initialDeviceData"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3" class="pt-2">
          <b-form-group id="model_label">
            <b-form-input
              id="gpsType"
              placeholder="Tipe GPS"
              v-model="deviceName"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <div class="mb-0">
        <div class="mb-0">
          <b-table
            small
            show-empty
            :fields="tblSensor"
            :items="dataSensorTable"
            class="datatables mt-3 border border-1"
            responsive="sm"
            empty-table
            :busy="loading"
          >
            <template #cell(pin)="data">
              <b-form-group>
                <multiselect
                  v-model="data.item.pin"
                  :options="data.item.pin_options"
                  placeholder="Pilih Pin"
                  trackBy="pin_code"
                  label="pin_name"
                  :allow-empty="false"
                  @input="(e) => onPinChange(e, data.item)"
                >
                </multiselect>
              </b-form-group>
            </template>
            <template #cell(status)="data">
              <b-form-group>
                <multiselect
                  v-model="data.item.status"
                  placeholder="Pilih Status "
                  :options="options"
                  label="text"
                  class="mb-12"
                  :allow-empty="false"
                >
                </multiselect>
              </b-form-group>
            </template>
            <template #cell(action)="data">
              <b-button class="mt-2" @click="save(data.item)">{{ $t('global.save') }}</b-button>
            </template>
          </b-table>
        </div>
      </div>

      <b-modal
        v-model="showModalMacAddress"
        class="mc-modal"
        id="modal-form"
        title="Set Mac Address BLE Sensor"
        size="md"
        centered
        :hide-header-close="loading"
        no-close-on-backdrop
      >
        <div class="card-body mc-modal__filter p-2">
          <b-form @submit.stop.prevent="handleSubmit">
            <div class="mb-2">
              <b-col cols="6">
                <label class="mt-3 required">{{ $t('sensor.macAddress') }}</label>
                <b-form-input
                  v-model="form.macAddress"
                  type="text"
                  :placeholder="$t('sensor.macAddress')"
                  :class="{
                    'is-invalid': $v.form.macAddress.$error,
                  }"
                >
                </b-form-input>
                <div v-if="$v.form.macAddress.$error" class="invalid-feedback">
                  <span v-if="!$v.form.macAddress.required">
                    {{ $t('sensor.required') }}
                  </span>
                  <span v-else-if="!$v.form.macAddress.minLength">
                    {{ `${$t('sensor.minLength')} 12 ${$t('sensor.character')}` }}
                  </span>
                  <span v-else-if="!$v.form.macAddress.maxLength">
                    {{ `${$t('sensor.maxLength')} 12 ${$t('sensor.character')}` }}
                  </span>
                  <span v-else-if="!$v.form.macAddress.macAddress">
                    {{ $t('global.validation.macAddress') }}
                  </span>
                  <span v-else-if="!$v.form.macAddress.isLowercase">
                    {{ $t('global.validation.isLowercase') }}
                  </span>
                  <span v-else-if="!$v.form.macAddress.isAlphaNum">
                    {{ $t('global.validation.isAlphaNum') }}
                  </span>
                </div>
              </b-col>
            </div>
          </b-form>
        </div>
        <template #modal-footer="{ cancel }">
          <b-row class="mc-modal__filter-footer">
            <b-col cols="12" class="mc-modal__filter-footer-btn">
              <b-button
                variant="outline-primary"
                @click="cancel()"
                :disabled="loading"
                class="me-3"
              >
                Batal
              </b-button>
              <b-button @click="handleSubmit" variant="primary" :disabled="loading">
                <b-spinner v-if="loading" small type="grow"></b-spinner>
                {{ loading ? 'Loading...' : $t('global.save') }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- Modal Khusus TFT100 (hanya untuk sensor OBD) -->
      <b-modal
        v-model="showModalTFT100"
        title="Set Brand dan Model"
        size="md"
        centered
        :hide-header-close="loading"
        no-close-on-backdrop
      >
        <div class="card-body">
          <b-form>
            <label class="required"> Brand </label>
            <multiselect
              v-model="tftForm.brand"
              :options="brands"
              placeholder="Pilih Brand"
              :allow-empty="false"
              track-by=""
              label=""
              :class="{
                'is-invalid': $v.tftForm.brand.$error,
              }"
              @input="(e) => onBrandChange(e, tftForm.brand)"
            />
            <div v-if="$v.tftForm.brand.$error" class="invalid-feedback">
              <span v-if="!$v.tftForm.brand.required"> Brand Wajib Dipilih </span>
            </div>

            <label class="mt-3 required"> Model </label>
            <multiselect
              v-model="tftForm.model"
              :options="models"
              placeholder="Pilih Model"
              :allow-empty="false"
              track-by=""
              label=""
              :class="{
                'is-invalid': $v.tftForm.model.$error,
              }"
            />
            <div v-if="$v.tftForm.model.$error" class="invalid-feedback">
              <span v-if="!$v.tftForm.model.required"> Model Wajib Dipilih </span>
            </div>

            <!-- Tambahkan field lain sesuai gambar jika ada -->
          </b-form>
        </div>

        <template #modal-footer>
          <b-button variant="outline-primary" @click="showModalTFT100 = false" :disabled="loading">
            Batal
          </b-button>
          <b-button variant="primary" @click="saveTFT100" :disabled="loading">
            <b-spinner v-if="loading" small type="grow"></b-spinner>
            {{ loading ? 'Loading...' : 'Simpan' }}
          </b-button>
        </template>
      </b-modal>
    </b-card>
  </div>
</template>
